<template>
  <div class="help">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Help Section</span>
      </heading-wrap>
      <div class="container-fluid site-content">
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading"><a name="top"></a>Table of contents</div>
            <div class="panel-body">
              <ul>
                <li><a href="#devguide">Dev Guide</a>
                  <ul>
                    <li><a href="#html">HTML &amp; Video (HTML) Units</a></li>
                    <li><a href="#psd">PSD Units</a></li>
                    <li><a href="#psdgifs">PSD Units - Animated Gifs</a></li>
                  </ul>
                </li>
                <li><a href="#exporting">Exporting</a></li>
                <li><a href="#adtags">AdTags</a></li>
                <li><a href="#faqs">FAQs</a></li>
              </ul>
            </div>
          </div>
        </div>
        <h2><a name="devguide"></a>Dev Guide</h2>
        <h3><a name="html"></a>HTML Units &amp; Video (HTML)</h3>
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">Package Structure</div>
            <div class="panel-body">
              <p>For HTML &amp; Video (HTML) Units your package structure will need each master must be contained in its own folder and an
                optional “_assets” directory at the root of the folder. The name of that folder will become the name of
                master in Otomo. The “_assets” directory is used to contain alternative images that will be used, eg a
                red CTA vs a green one. All images included in the master file will also get uploaded and be available
                as an option.</p>
              <p>In short your folder that gets zipped up should look like this:</p>
              <code>root (/)
                <ul>
                  <li>_assets</li>
                  <li>160x600</li>
                  <ul>
                    <ul>
                      <li>index.html</li>
                      <li>styles.css</li>
                      <li>main.js</li>
                      <ul>
                        <li>images</li>
                        <ul>
                          <li>image1.jpg</li>
                          <li>etc</li>
                        </ul>
                      </ul>
                    </ul>
                  </ul>
                  <li>300x250</li>
                  <ul>
                    <ul>
                      <li>index.html</li>
                      <li>styles.css</li>
                      <li>main.js</li>
                      <ul>
                        <li>images</li>
                        <ul>
                          <li>image1.jpg</li>
                          <li>etc</li>
                        </ul>
                      </ul>
                    </ul>
                  </ul>
                </ul>
              </code>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">Tagging Syntax</div>
            <div class="panel-body">
              <p>For HTML &amp; Video (HTML) files you will need to tag up the files using the syntax listed below. Images need to be in
                img tags, css parameters like headline colors etc should be in a css file and js variables like number
                of frames, frame length should be in a js file. These ads can then be tagged for otomo accordingly
                using:</p>
              <ul>
                <h5>HTML</h5>
                <li><code>otomo-image="varname"</code>for html image tags (as a data attribute)</li>
                <li><code>otomo-string="varname" </code> for html text divs (as a data attribute)</li>
                <li><code>otomo-number="varname"</code> for html text divs that contain numbers (as a data attribute)</li>
                <li><code>otomo-video="varname"</code> for html video tags (as a data attribute)</li>
                <li><code>otomo-video-src="varname"</code> for html video source tags( as a data attribute)</li>
                <li><code>otomo-thumb="png"</code> on any html element to grab it as an image file. The choices for the var name are jpg, png or gif. This can be used to take a static screenshot of the first frame of the banner</li>
                <li><code>otomo-thumb-delay="15"</code> on the same html element that <code>otomo-thumb</code> is applied to. This is an optional attribute that will delay the snapshot being taken.</li>
                <li><code>otomo-thumb-jquality="75"</code> otomo-thumb-jquality can now be used as a data attribute in addition to <code>otomo-thumb</code>. This is an optional attribute that will control the quality of the jpeg being taken. It must be a value between 1-100.</li>

                <h5>Height &amp; Width</h5>
                <p>For an optimal experience in the system you can define the height and width of your master as meta data attribute. This ensures that preview urls use the right dimensions for each master. They can be overridden on an individual level.</p>
                <li><code>&lt;meta name="otomo:width" content="300"&gt;</code> metatag to define the width of the unit in pixels</li>
                <li><code>&lt;meta name="otomo:height" content="250"&gt;</code> metatag to define the height of the unit in pixels</li>
                <h5>Video (HTML) units only</h5>
                <li><code>&lt;meta name="otomo:video:duration" content="7.5"&gt;</code> metatag to define the duration of the video, must be a number (eg 7.25)</li>
                <li><code>&lt;meta name="otomo:video:fps" content="15"&gt;</code> metatag to define the "Frames per second" of the video, allowed values are "12", "15", "24", "25", "29","30","50" or "60"</li>
                <li><code>&lt;meta name="otomo:video:format" content="mp4"&gt;</code> metatag to define the duration of the video, can be either "mp4" or "gif"</li>
                <h5>CSS</h5>
                <li><code>/* @otomo string varname */</code> for CSS properties as a comment on the same line as the css property. Each CSS property should ideally be on its own line.</li>
                <li><code>/* @otomo number varname */ </code> for CSS properties that are numerical as a comment on thesame line as the css property. Each CSS property should ideally be on its own line.</li>
                <li><code>/* @otomo color varname */ </code> for CSS properties that are color as a comment on thesame line as the css property. Each CSS property should ideally be on its own line. This datatype will launch a color picker to the user and will accept Hex and rgba values</li>
                <h5>JS</h5>
                <li><code>/* @otomo string varname */ </code> for js variables as a comment on the same line as the variable</li>
                <li><code>/* @otomo number varname */ </code> for js variables that are numerical as a comment on the same line as the variable</li>
                <li><code>/* @otomo color varname */ </code> for js variables that are color as a comment on the same line as the variable. This datatype will launch a color picker to the user and will accept Hex and rgba values</li>
                <li><code>/* @otomo boolean varname */ </code> for js variables that are boolean as a comment on the same line as the variable. This datatype will only let the user select TRUE or FALSE as a value.</li>
                <li><code>/* @otomo yesno varname */ </code> for js variables that can only be "yes" or "no". The output values are case sensitive and will always output lowercase.</li>
              </ul>
              <p>Files that are not tagged will get analysed but what gets brought back to the user will only be what's
                in the HTML file. Ie any <code>img</code> tags or <code>div</code> tags containing just text will get
                picked up if no tag can be found in the file.</p>
              <p>The following values are reserved system names and can not be used as variables, ['master', 'locale'].  These system names are mandatory for every unit ['width', 'height'] and can be referenced as variables in your files but will only be available as "number" types </p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">HTML Notes</div>
              <div class="panel-body">
                <ul>
                  <li>Duplicate Otomo tags in a HTML unit will not get rendered, only the first instance of that tag will get
                  updated.</li>
                  <li>The following column names are reserved and used by the system. "master", "locale", "width", "height" . Thes are madatory for each unit.</li>
                </ul>
                <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
              </div>
            </div>
          </div>
        <h3><a name="psd"></a>PSD Units</h3>
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">Package Structure</div>
            <div class="panel-body">
              <p>For PSD units the package will be much simpler. All that is needed is the PSD in the root of the folder
                as follows: </p>
              <code>root (/)
                <ul>
                  <li>160x600.psd</li>
                  <li>300x250.psd</li>
                  <li>970x250.psd</li>
                </ul>
              </code>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">Tagging synatx</div>
            <div class="panel-body">
              <p>The system can analyse tagged or untagged files. To tag a layer for editing the all you need to do is add the prefix "otomo-" to the layer name. If a file is untagged then every possible editable layer will be returned as an option, and you can enable or disable layers that you don't want to change. Any locked layers will not be editable.</p>
              <h5>Text layers</h5>
              <p>For each text layer found the system will return 4 fields. One for the Text value, one for the
                fontsize, one for color and one for alignment. Eg. If the layer found in the file is labelled as
                “baseline”, the user will be able to enable/disable the following layers: </p>
              <li><code>baseline</code> Used for the content of the layer</li>
              <li><code>baseline:fontsize</code>Controls the fontsize of the unit.
                <ul>
                  <li>This is a numerical value and the unit will have already been set in the PSD.</li>
                  <li>The textbox may be small and not allow for large fonts, so sometimes increasing the font size
                    makes the text not appear on the canvas.
                  </li>
                </ul>
              </li>
              <li><code>baseline:color</code>Hex value of the color that you want to use.</li>
              <li><code>baseline:alignment</code>Options are [ “left”, “right”, “center”] . Note. This is within the
                confines of the textbox that the user has set and not the overall design.
                Renders will only fail if layers are locked in the PSD but otherwise the only problem you will get back
                should be a visible one. Eg the font is different.</li>
              <h5>Image / Bitmap layers</h5>
              <p>The system will also analyse image layers and make them editable. Bitmap layers, smartObject layers and vector layers will be analysed by the system and become available for editing if they are not locked. Fill/Shape layers are currently unavailable.</p>
              <p>For each image layer found the system will return 3 fields. One for the image value [ie the new png, jpg or gif that will be used], one for the
                maintaining the Aspect Ratio and one for constraining image . Eg. If the layer found in the file is labelled as
                headerimage, the user will be able to enable/disable the following layers: </p>
              <li><code>headerimage</code> Used for the content of the layer</li>
              <li><code>headerimage:constrain</code>This controls whether or not the new image will not exceed the height and width dimensions of the original image it is replacing. This can be set to true or false.</li>
              <li><code>headerimage:keepAspect</code>This controls whether or not the newly placed image will maintain its own original aspect ratio. If the constrain property is set to true and this property is false, the result will be a skewed image. This can be set to true or false.</li>

              <h4>Example of image properties</h4>
              <p>As an example, lets state that we have a 400px by 250px banner with a light blue blackground and an image layer in our PSD is 250px by 250px. Our replacement image will be 250px by 400px.</p>
              <div class="col-sm-6 exampleHolder">
                <div class="imgExample">
                  <img src="https://placeimg.com/250/250/arch"/>
                </div>
                <p class="caption">Original</p>
              </div>
              <div class="col-sm-6 exampleHolder">
                <div class="imgExample">
                  <img src="https://placeimg.com/250/400/people"/>
                </div>
                <p class="caption">Constrain FALSE, keepAspect FALSE </p>
              </div>
              <div class="col-sm-6 exampleHolder">
                <div class="imgExample">
                  <img width="250" height="250" src="https://placeimg.com/250/400/people"/>
                </div>
                <p class="caption">Constrain TRUE, keepAspect FALSE </p>
              </div>
              <div class="col-sm-6 exampleHolder">
                <div class="imgExample">
                  <img width="156" height="250" src="https://placeimg.com/250/400/people"/>
                </div>
                <p class="caption">Constrain TRUE, keepAspect TRUE </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">PSD Notes</div>
            <div class="panel-body">
              <ul>
                <li>Master names in your external CSVs for PSD render jobs will need to include the extension.</li>
                <li>Layer styles & Blend modes can't be copied. If you have a layer that still needs layer styles or blend modes applied once replaced, you can place your layer in a folder in photoshop and apply the layer styles/blend modes to that folder.</li>
                <li>Currently all layer replacements will place the new image and scale from the top left corner of the original asset.</li>
                <li>All layers that are to be replaced must be uniquely named. If two layers share a name then only the first instance will be replaced.</li>
                <li>Locked layers will be ignored.</li>
                <li>Layer order will be respected and can not currently be re-ordered.</li>
                <li>Opacity & visibility of the original layers will be carried across.</li>
                <li>Complex masks (eg ones with gradients and fades) should be applied in a similar fashion to layer styles, ie on a folder containing the asset you want to replace. Basic masks (Square shapes) will be carried across to the new layer.</li>
                <li>For best results avoid using special characters in layer names like '%,!,@,£,$' etc. using ':' will result in failure for renders</li>
                <li>Layer names should be less than 48 characters long</li>
                <li>The following column names are reserved and used by the system. "master", "locale", "width", "height" . Thes are madatory for each unit.</li>
              </ul>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <h3><a name="psdgifs"></a>PSD Units - Animated Gifs</h3>
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">Extra considerations</div>
            <div class="panel-body">
              <p>When creating animated GIFs using the PSD service the following additional considerations need to be made when using a master that also includes animated bitmap/smart object layers.</p>
              <li>Any image layers that will be animated and replaced by Otomo on the timeline must be converted into smart objects with any animations being on the layer in the main PSD and not inside the smart Object. If you only want to alter text layers, best practise would be to tag the text layers only.</li>
              <li>Each Image layer that has animation properties against will also need a key frame at time == 0.</li>
              <li>A background colour layer should be used as base layer.</li>
              <li>Any image layers that will be replaced must only be replaced with images that are the exact same size.</li>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <h2><a name="exporting"></a>Exporting</h2>
        <!--Exporting-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">Exporting Advanced options</div>
            <div class="panel-body">
              <p>On the creative unit page, where bulk operations can be made, you can choose some additional options when exporting (downloading) your creative units from the system.</p>
              <h4>Naming convention</h4>
              <p>This option allows you to change the naming convention applied to each creative unit when you download your assets. As a default the naming convention is made up of the "master" &amp; "locale" columns, but you can alternatively select each of those two columns individually.</p>
              <h4>Zip</h4>
              <p>This option is enabled by default and when enabled each creative will be in its own zip file after you download your assets. If its disabled, then your download zip will contain folders for each creative unit.</p>
              <h4>Formats [PSD only]</h4>
              <p>This section will allow you to specify which formats you want included as part of your download for each creative unit. As a default "png" is selected.</p>
              <h4>Group By [PSD Only]</h4>
              <p>This option groups all the outputs of a creative unit into one folder, if not selected then all the outputs will be in a flat folder structure.</p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
         <h2><a name="adtags"></a>AdTags</h2>
        <!--AdTags-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">AdTag Preperation</div>
            <div class="panel-body">
              <p>In order to use Otomo to generate AdTags for your campaign CTAs must use the following code:</p>
              <pre>
                <code>
                  {{ tagCode() }}
                </code>
              </pre>
              <h4>Code explanation</h4>
              <p>"ctaHolder" is the id of the html element that will be the CTA in you creative. This portion of the code above can be swapped out as required.</p>
              <p>The code above includes an additional variable called "defaultClickTag" which is tagged as an Otomo variable "clickTag". What this allows you to do is set clickTags individually against creative units and if no url is passed into the AdTag via the adserver the creative unit will use the default you set against it.</p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <h2><a name="faqs"></a>FAQs</h2>
        <!--question-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">My render seems to be stuck. Who can I speak to about investigating this issue?</div>
            <div class="panel-body">
              <p>Send an email to <a href="mailto:support@otomo.io">support@otomo.io</a> with a link to your creative on
                Otomo and if possible any data sheets that were used to populate the versions table.</p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <!--question-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">How to put a break line in my HTML creative?</div>
            <div class="panel-body">
              <p>Break lines can be entered into the system using "&lt;br&gt;" tags or "\n".</p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <!--question-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">My PSD text doesn't look right</div>
            <div class="panel-body">
              <p>This is more than likely because a font is missing. Send an email to <a href="mailto:support@otomo.io">support@otomo.io</a> with a link to your fonts (either an otf or ttf format, along with any licensing information you have) and we can get it installed for you. </p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <!--question-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">When I export multiple formats for a creative unit, will I get charged multiple times?</div>
            <div class="panel-body">
              <p>No, you will only get charged once per creative unit. If you decide to export a JPG, PNG and GIF for a PSD creative type, you will only be charged once. If you decide to edit this unit further and export again, a new charge will be counted against your account. </p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <!--question-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">I cant preview my video in the asset library</div>
            <div class="panel-body">
              <p>The previewer looks for mp4 files, so if your file is not an mp4 the previewer will not work.</p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <!--question-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">Can I generate backup images of my HTML?</div>
            <div class="panel-body">
              <p>Yes, there is a guide <a href="https://support.otomo.io/support/solutions/articles/36000046976-can-i-generate-backup-images-of-my-html-" target="_blank">here</a></p>
              <a href="#top">Back to top <i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <!--question-->
        <div class="col-md-12">
          <div class="panel  panel-default">
            <div class="panel-heading">Sometimes when downloading a CSV my characters don't appear properly in Excel.</div>
            <div class="panel-body">
              <p>The system relies on CSVs being formatted as a UTF-8 encoded file. This means any applications you use to open / edit the CSVs should adhere to this, otherwise you may experience characters like #, £ or $ not appearing properly. Text editors like <a href="https://www.sublimetext.com/" target="_blank">sublime</a> or an online spreadsheet service like <a href="https://www.google.co.uk/sheets/about/" target="_blank">Google Sheets</a> are applications that we would recommmend using for editing CSVs outside of Otomo</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'

export default {
  name: 'Help',
  components: {
    HeadingWrap
  },
  data: () => ({}),
  created () {
    this.enableHelpWidget()
    document.body.classList.add('helpPage')
  },
  computed: {},
  methods: {
    tagCode () {
      var tagcode = '\n' +
      '<script type="text/javascript"> \n' +
        '  function getQueryVariable(variable) { \n' +
        '     var query = window.location.search.substring(1); \n' +
        '     var vars = query.split("&"); \n' +
        '     for (var i = 0; i < vars.length; i++) { \n' +
        '       var pair = vars[i].split("="); \n' +
        '       if (decodeURIComponent(pair[0]) == variable) { \n' +
        '        return decodeURIComponent(pair[1]); \n' +
        '      } \n' +
        '     } \n' +
        '    } \n\n\n' +
        ' var defaultClickTag = "https://www.intel.com/"; /* @otomo string clickTag */ \n' +
        ' var clickTag = getQueryVariable("clickTag") ?  getQueryVariable("clickTag") : defaultClickTag;\n' +
        ' document.getElementById("ctaHolder").addEventListener("click", this.exitHandler, false);\n\n' +
        ' function bgExitHandler(e) { \n' +
        '  window.open(clickTag, "_blank");\n' +
        ' }\n' +
        '<script>'
      return tagcode
    },
    enableHelpWidget () {
      let helpWidgetScript = document.createElement('script')
      helpWidgetScript.id = 'helpWidget'
      // const code = 'var fc_CSS=document.createElement(\'link\');fc_CSS.setAttribute(\'rel\',\'stylesheet\');var fc_isSecured = (window.location && window.location.protocol == \'https:\');var fc_lang = document.getElementsByTagName(\'html\')[0].getAttribute(\'lang\'); var fc_rtlLanguages = [\'ar\',\'he\']; var fc_rtlSuffix = (fc_rtlLanguages.indexOf(fc_lang) >= 0) ? \'-rtl\' : \'\';fc_CSS.setAttribute(\'type\',\'text/css\');fc_CSS.setAttribute(\'href\',((fc_isSecured)? \'https://d36mpcpuzc4ztk.cloudfront.net\':\'http://assets1.chat.freshdesk.com\')+\'/css/visitor\'+fc_rtlSuffix+\'.css\');document.getElementsByTagName(\'head\')[0].appendChild(fc_CSS);var fc_JS=document.createElement(\'script\'); fc_JS.type=\'text/javascript\'; fc_JS.defer=true;fc_JS.src=((fc_isSecured)?\'https://d36mpcpuzc4ztk.cloudfront.net\':\'http://assets.chat.freshdesk.com\')+\'/js/visitor.js\';(document.body?document.body:document.getElementsByTagName(\'head\')[0]).appendChild(fc_JS);window.livechat_setting= \'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\';'
      const code = 'function initFreshChat() {window.fcWidget.init({token: "db8bae3b-bf80-4ab7-b10e-16bbcfc2d7e7",host: "https://wchat.freshchat.com"});} function initialize(i,t){var e;i.getElementById(t)?initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,e.src="https://wchat.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}function initiateCall(){initialize(document,"freshchat-js-sdk")}window.addEventListener?window.addEventListener("load",initiateCall,!1):window.attachEvent("load",initiateCall,!1);'
      helpWidgetScript.text = code
      document.body.appendChild(helpWidgetScript)
    }
  },
  beforeRouteLeave (to, from, next) {
    document.body.classList.remove('helpPage')
    next()
  }
}
</script>

<style lang="scss">
@import "../scss/variables";
.helpPage {
  & .panel-heading{
    background-color: $backgroundBrand;
    color:white;
  }
  & .exampleHolder {
    text-align: center;
  }
  & .imgExample {
    background-color: rgb(139, 193, 224);
    width:400px;
    height:250px;
    overflow: hidden;
    border:1px solid gray;
    margin:0 auto;
  }
  & .caption {
      font-style: italic;
      text-align: center;
    }

}

.fc-widget-small {
    display: none;
  }
  .helpPage {
    .fc-widget-small {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/help.vue